import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import PrimaryButton from '../PrimaryButton';
import { useAuth } from '../../../hooks/auth';

import { BlockedNotice } from './styles';

interface ICreateTournamentButtonProps {
  /** Repassado ao botão — as páginas de torneio estilizam pelo id. */
  id?: string;
  label?: string;
}

/**
 * Botão de criar torneio, desabilitado enquanto o usuário estiver na escola
 * padrão da plataforma — a única consequência que sobrou dela.
 *
 * Renderiza SÓ o botão, sem wrapper: os cabeçalhos das duas páginas de torneio
 * dimensionam o botão por `> .primary-button`, e qualquer elemento no meio
 * quebraria esse seletor. A explicação vive no `TournamentSchoolNotice`, que
 * cada página posiciona onde couber.
 */
export const CreateTournamentButton: React.FC<ICreateTournamentButtonProps> = ({
  id,
  label = 'Criar Torneio Local',
}) => {
  const navigate = useNavigate();
  const { onDefaultSchool } = useAuth();

  const handleClick = useCallback(() => {
    navigate('/tournament/create');
  }, [navigate]);

  return (
    <PrimaryButton
      id={id}
      type="button"
      onClick={handleClick}
      disabled={onDefaultSchool}
      // O botão cinza sozinho não diz o porquê para quem usa leitor de tela
      // nem para quem passa o mouse antes de ler o aviso.
      title={
        onDefaultSchool
          ? 'É preciso escolher a escola do seu colégio no perfil para criar um torneio.'
          : undefined
      }
    >
      {label}
    </PrimaryButton>
  );
};

/**
 * Motivo do botão desabilitado. Fica junto do botão de propósito: se as duas
 * páginas escrevessem a própria mensagem, o mesmo bloqueio seria explicado de
 * um jeito na lista e de outro no briefing.
 */
export const TournamentSchoolNotice: React.FC = () => {
  const navigate = useNavigate();
  const { onDefaultSchool } = useAuth();

  if (!onDefaultSchool) {
    return null;
  }

  return (
    <BlockedNotice>
      Para criar um torneio, troque a escola padrão (Fuzzy Makers) pelo colégio
      ao qual você pertence — se ele ainda não existir na plataforma, dá para
      cadastrá-lo na hora.{' '}
      <button type="button" onClick={() => navigate('/profile')}>
        Alterar escola no perfil
      </button>
    </BlockedNotice>
  );
};

export default CreateTournamentButton;
